module.exports = "<p>lista-asociaciones works!</p>\n"